var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCustomerMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "45.9707031,9.0146484 38.9853516,9.0146484 38.9853516,2.0292969 36.9853516,2.0292969 36.9853516,9.0146484  30,9.0146484 30,11.0146484 36.9853516,11.0146484 36.9853516,18 38.9853516,18 38.9853516,11.0146484 45.9707031,11.0146484  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,28c3.3789062,0,6-4.7753906,6-8.8828125C24,15.8037109,23.3183594,12,18,12s-6,3.7412109-6,7 C12,23.6259766,14.9160156,28,18,28z M18,14c2.9902344,0,4,1.2910156,4,5.1171875C22,22.6621094,19.7460938,26,18,26 s-4-3.3945312-4-7C14,15.2148438,14.9716797,14,18,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3193359,32.4921875C28.3876953,31.5615234,24.2167969,30,18,30S7.6123047,31.5615234,5.6796875,32.4931641 C4.6591797,32.9853516,4,34.0429688,4,35.1875V44h2v-8.8125c0-0.3876953,0.2099609-0.7294922,0.5478516-0.8925781 C8.3271484,33.4375,12.1796875,32,18,32s9.6728516,1.4375,11.4511719,2.2939453C29.7900391,34.4580078,30,34.7998047,30,35.1875V44 h2v-8.8125C32,34.0429688,31.3408203,32.9853516,30.3193359,32.4921875z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomerMedium);
export default __webpack_public_path__ + "static/media/new-customer--medium.18a1b62b0eb84397345b18a4b43e586c.svg";
export { ForwardRef as ReactComponent };